import { Navigate, Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useSubscriptionStore } from '../stores/subscriptionStore';
import { ROUTES } from '../constants/routes';
import { MODULES } from '../constants/modules';

interface ModuleGuardProps {
  moduleId?: string;
}

export default function ModuleGuard({ moduleId }: ModuleGuardProps) {
  const tier = useSubscriptionStore((s) => s.tier);
  const isLocked = useSubscriptionStore((s) => s.isLocked);
  const hasModule = useSubscriptionStore((s) => s.hasModule);
  const bootstrapComplete = useSubscriptionStore((s) => s.bootstrapComplete);

  // Block rendering until subscription bootstrap completes to prevent false module locks
  if (!bootstrapComplete) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // No subscription (company without a plan) — allow access
  if (!tier) return <Outlet />;

  if (isLocked()) {
    return <Navigate to={ROUTES.SUBSCRIPTION_LOCKED} replace />;
  }

  // AI Copilot and Fast Inspections are always accessible
  if (moduleId && moduleId !== MODULES.AI_COPILOT && moduleId !== MODULES.FAST_INSPECTIONS && !hasModule(moduleId)) {
    return <Navigate to={`${ROUTES.UPGRADE}?module=${moduleId}`} replace />;
  }

  return <Outlet />;
}
